var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"data-aos":"fade-up","data-aos-offset":"200","data-aos-duration":"1000","data-aos-easing":"ease-in-out","data-aos-mirror":"true","data-aos-once":"false"}},[_c('div',[_c('h1',{staticClass:"text-center pb-6 font--Menu--Text"},[_vm._v("Kundenbewertungen")]),_c('ClientsReviews')],1),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }